/*
 * 导出面板（对齐 Figma）
 *   ┌─────────────────────────────┐
 *   │ 导出                          │
 *   │ 📄 文件名.docx       约 X MB  │
 *   │ ┌─────────────────────────┐ │
 *   │ │  ↓  导出 Word 文档       │ │ ← 主紫色按钮
 *   │ └─────────────────────────┘ │
 *   └─────────────────────────────┘
 */

import React from 'react'

interface Props {
  data: {
    /** 文件名（含扩展名） */
    fileName?: string
    /** 文件大小友好字符串，如 "约 2.4 MB" */
    fileSize?: string
    /** 主按钮文案，默认 "导出 Word 文档" */
    buttonText?: string
    /** （可选）多格式时的格式列表；不传则单按钮模式 */
    formats?: Array<{ key: string; label: string; ext: string; emoji?: string }>
    /** 默认选中的格式 key（多格式模式） */
    defaultFormat?: string
  }
  onExport: (format: string) => void
}

const FILE_EMOJI = '📄'

export const ExportPanel: React.FC<Props> = ({ data, onExport }) => {
  const hasMultiFormat = !!(data.formats && data.formats.length > 1)
  const [active, setActive] = React.useState(
    data.defaultFormat || (data.formats && data.formats[0]?.key) || 'docx'
  )

  return (
    <div className="aiClerk-att-export">
      <div className="aiClerk-att-export__title">导出</div>

      {data.fileName && (
        <div className="aiClerk-att-export__file-row">
          <span className="aiClerk-att-export__file-icon">{FILE_EMOJI}</span>
          <span className="aiClerk-att-export__file-name" title={data.fileName}>
            {data.fileName}
          </span>
          {data.fileSize && (
            <span className="aiClerk-att-export__file-size">
              {data.fileSize}
            </span>
          )}
        </div>
      )}

      {hasMultiFormat && (
        <div className="aiClerk-att-export__formats">
          {data.formats!.map((f) => (
            <button
              key={f.key}
              type="button"
              className={
                'aiClerk-att-export__format' +
                (f.key === active ? ' is-active' : '')
              }
              onClick={() => setActive(f.key)}
            >
              <div className="aiClerk-att-export__emoji">{f.emoji || '📄'}</div>
              <div className="aiClerk-att-export__label">{f.label}</div>
              <div className="aiClerk-att-export__ext">{f.ext}</div>
            </button>
          ))}
        </div>
      )}

      <button
        type="button"
        className="aiClerk-att-export__btn"
        onClick={() => onExport(active)}
      >
        <span className="aiClerk-att-export__btn-arrow">↓</span>
        {data.buttonText || '导出 Word 文档'}
      </button>
    </div>
  )
}
